import React from 'react'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import { pathwayShortLabel } from '../../../training/components/admin/catalogueHelpers'

// Which roles need the course. A role's value is true/false, or, when the
// course is linked to an e-learning course with more than one pathway
// (`pathways` given), the id of the pathway that role must complete.
const Roles = ({
  addCourseFormValues: formValues,
  setAddCourseFormValues: setFormValues,
  roles,
  pathways = [],
}) => {
  const setRole = (role, value) =>
    setFormValues((prev) => ({
      ...prev,
      requiredBy: { ...prev.requiredBy, [role]: value },
    }))

  if (pathways.length > 1) {
    return (
      <Grid container spacing={1.5}>
        {roles.map((role) => {
          const value = formValues.requiredBy[role]
          return (
            <Grid item xs={12} md={6} key={role}>
              <TextField
                select
                size="small"
                fullWidth
                label={role}
                value={typeof value === 'string' && value ? value : ''}
                onChange={(e) => setRole(role, e.target.value || false)}
                SelectProps={{ displayEmpty: true }}
                InputLabelProps={{ shrink: true }}
              >
                <MenuItem value="">Not required</MenuItem>
                {pathways.map((pathway) => (
                  <MenuItem key={pathway.id} value={pathway.id}>
                    {pathwayShortLabel(pathway)}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )
        })}
      </Grid>
    )
  }

  return (
    <FormGroup>
      <Grid container>
        {roles.map((role) => (
          <Grid item xs={12} md={6} key={role}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!formValues.requiredBy[role]}
                  onChange={(e) => setRole(role, e.target.checked)}
                />
              }
              label={role}
            />
          </Grid>
        ))}
      </Grid>
    </FormGroup>
  )
}

export default Roles
